import React, { Fragment } from 'react';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export default [
  {
    header: (
      <>
        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
        <TranslatedCopy id='global.size' />{' '}
      </>
    ),
    id: 'code'
  },
  {
    header: (data, { totalRequestedQty }) => (
      <div className='flex-container row align-center'>
        <span className='d-sm-h d-md-b'>
          <TranslatedCopy id='global.requested' />
          {': '}
          {totalRequestedQty}
        </span>
      </div>
    ),
    id: 'totalRequestedQty'
  },
  {
    header: (data, { totalConfirmedQty }) => (
      <div className='flex-container row align-center'>
        <span className='d-sm-h d-md-b'>
          <TranslatedCopy id='global.confirmed' />
          {': '}
          {totalConfirmedQty}
        </span>
      </div>
    ),
    id: 'totalConfirmedQty'
  },
  {
    header: (data, { totalOpenReferenceQty }) => (
      <div className='flex-container row align-center'>
        <span className='d-sm-h d-md-b'>
          <TranslatedCopy id='global.reference' />
          {': '}
          {totalOpenReferenceQty}
        </span>
      </div>
    ),
    id: 'totalOpenReferenceQty'
  },
  {
    header: (data, { totalReservedQty }) => (
      <div className='flex-container row align-center'>
        <span className='d-sm-h d-md-b'>
          <TranslatedCopy id='global.reserved' />
          {': '}
          {totalReservedQty}
        </span>
      </div>
    ),
    id: 'totalReservedQty'
  },
  {
    header: (data, { totalCancelledQty }) => (
      <div className='flex-container row align-center'>
        <span className='d-sm-h d-md-b'>
          <TranslatedCopy id='global.cancelled' />
          {': '}
          {totalCancelledQty}
        </span>
      </div>
    ),
    id: 'totalCancelledQty',
    cell: data => {
      return data.totalCancelledQty > 0 ? (
        <div
          style={{
            backgroundColor: '#f200001a',
            width: '100%',
            height: '100%',
            textAlign: 'center',
            paddingTop: '10px'
          }}
        >
          <span className='text-color-error'>{data.totalCancelledQty}</span>
        </div>
      ) : (
        <span>{data.totalCancelledQty}</span>
      );
    }
  }
];
